export { default } from "./RemindIcon";
